import { useState } from "react";
import { Volume2, Loader2, Square } from "lucide-react";

const LANG_VOICE = {
  en: "en-US",
  hi: "hi-IN",
  te: "te-IN",
};

export default function SpeakButton({ text, lang = "en", label, size = "sm", className = "", testId }) {
  const [speaking, setSpeaking] = useState(false);

  const speak = () => {
    if (!text || !text.trim()) return;
    if (typeof window === "undefined" || !window.speechSynthesis) {
      alert("Voice playback isn't supported in this browser.");
      return;
    }
    if (speaking) {
      window.speechSynthesis.cancel();
      setSpeaking(false);
      return;
    }
    const u = new SpeechSynthesisUtterance(text);
    u.lang = LANG_VOICE[lang] || "en-US";
    u.rate = 0.95;
    u.pitch = 1.0;
    // Pick the best matching voice on this device
    const voices = window.speechSynthesis.getVoices();
    const match = voices.find((v) => v.lang.toLowerCase().startsWith(u.lang.toLowerCase().split("-")[0]));
    if (match) u.voice = match;
    u.onend = () => setSpeaking(false);
    u.onerror = () => setSpeaking(false);
    window.speechSynthesis.speak(u);
    setSpeaking(true);
  };

  const sizing = size === "sm" ? "h-7 w-7" : "h-9 w-9";

  return (
    <button
      onClick={speak}
      className={`inline-flex items-center justify-center rounded-lg transition ${sizing} ${speaking ? "bg-[#f37021] text-white animate-pulse" : "bg-[#e6f0ff] text-[#004a99] hover:bg-[#cfe1ff]"} ${className}`}
      title={label || `Listen (${lang.toUpperCase()})`}
      data-testid={testId}
    >
      {speaking ? <Square className="h-3.5 w-3.5" /> : <Volume2 className="h-3.5 w-3.5" />}
    </button>
  );
}
